import * as React from 'react'
import { renderCatch } from '../error/renderCatch'
import type { CommonDeps } from '../base/CommonDeps'
import { withS3Url } from '../file/withS3Url'

type Props = {
    deps: CommonDeps
    url: string
    autoPlay?: boolean
}

export class Video extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    public tryRender = () => {
        const { autoPlay, url } = this.props

        return withS3Url(this.props.deps, url, ({ fullSizeS3Url }) => (
            <video controls loop preload="auto" playsInline autoPlay={autoPlay}>
                <source src={fullSizeS3Url ?? url} />
            </video>
        ))
    }
}
